module.exports = __webpack_public_path__ + "static/remy-finet-9daa90eb06d87f465804ee8d45ef79c8.jpg";